(function($){
  $(document).ready(function(){

    // Start Defer YouTube videos
    function init() {
        var vidDefer = document.getElementsByTagName('iframe');
        for (var i=0; i<vidDefer.length; i++) {
          if(vidDefer[i].getAttribute('data-src')) {
            vidDefer[i].setAttribute('src',vidDefer[i].getAttribute('data-src'));
          }
        }
      }
      window.onload = init;

      // End Defer YouTube videos

      // Start Sliders

      $('.hero-slider').slick({
        arrows: false,
        dots: false,
        speed: 2000,
        autoplay: true,
        autoplaySpeed: 8000
      });

      $('.product-slider').slick({
        arrows: true,
        dots: false,
        speed: 2000,
        autoplay: true,
        autoplaySpeed: 8000,
        adaptiveHeight: true,
        nextArrow: '<i class="fas fa-chevron-right"></i>',
        prevArrow: '<i class="fas fa-chevron-left"></i>',
      });


      // End Sliders

      $('.widget_nav_menu ul.menu li.menu-item-has-children').prepend('<i class="fas fa-plus"></i>');

      $('.widget_nav_menu ul.menu li.menu-item-has-children i').parent().on('click', function(e){
          // e.preventDefault();
          $(this).toggleClass('expanded');
          $(this).find('i').toggleClass('fa-plus fa-minus');
      });

      $('.selected-menu li.menu-item-has-children').prepend('<i class="fas fa-plus"></i>');

      $('.selected-menu li.menu-item-has-children i').parent().on('click', function(e){
          // e.preventDefault();
          $(this).toggleClass('expanded');
          $(this).find('i').toggleClass('fa-plus fa-minus');
      });



      //Background horizontal movement on scroll
      // $(window).on('scroll', function () {
      //     var scrollTop     = $(window).scrollTop(),
      //         elementOffset = $('.about-us-layout').offset().top,
      //         distance      = (elementOffset - scrollTop);
      //
      //    $('.about-us-layout').css('background-position',  distance + 'px top');
      // });

      // Expand credit card details on mobile
      $('.expand-link').on('click', function(){
        $(this).closest('.credit-card-block').find(".zip").slideToggle();
        if($(this).html() == 'View Details') {
          $(this).html('View Less');
        } else {
          $(this).html('View Details');
        }

      });


      // Clipboard
      var clipboard = new ClipboardJS('.clip');
      clipboard.on('success', function(e) {
          console.log(e);
      });
      clipboard.on('error', function(e) {
          console.log(e);
      });

      // Add colored underline on menu item hover
      $('ul#main-nav li').hover(function(){
          var color = $(this).data('color');
          // console.log(color);
          if(color) {
            $(this).css('border-color', color);
          }
        }, function(){
          $(this).css('border-color', 'transparent');
      });

      $("#jump-icon").click(function () {
         $("html, body").animate({scrollTop: 0}, 1000);
      });


      // var field = get_field('alerts_repeater_color', 'option');
      // Customize Color Picker
      acf.add_filter('color_picker_args', function( $args, $field ){

      	// do something to args
      	args.palettes = ['#5ee8bf', '#2f353e', '#f55e4f']


      	// return
      	return args;

      });

  });

})(jQuery);
